export function setCookie(name, value, options = {}) {
  const {
    days     = null,
    sameSite = 'Strict',
    secure   = location.protocol === 'https:',
    path     = '/',
  } = options

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
  cookie += `; path=${path}`
  cookie += `; SameSite=${sameSite}`
  if (secure) cookie += '; Secure'
  if (days !== null) {
    const expires = new Date(Date.now() + days * 864e5)
    cookie += `; expires=${expires.toUTCString()}`
  }

  document.cookie = cookie
}

export function getCookie(name) {
  const encoded = encodeURIComponent(name)
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(`${encoded}=`))
  if (!match) return null
  return decodeURIComponent(match.split('=').slice(1).join('='))
}

export function deleteCookie(name, path = '/') {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}; SameSite=Strict`
}

const PREFS = {
  THEME:       'aerj_theme',
  LANGUAGE:    'aerj_lang',
  REMEMBER_ME: 'aerj_remember',
  SIDEBAR:     'aerj_sidebar',
}

const TTL = {
  THEME:       365,
  LANGUAGE:    365,
  REMEMBER_ME: 30,
  SIDEBAR:     90,
}

const COOKIE_OPTS = {
  sameSite: 'Strict',
}

export const prefs = {
  getTheme()        { return getCookie(PREFS.THEME) || 'light' },
  setTheme(theme)   { setCookie(PREFS.THEME, theme, { ...COOKIE_OPTS, days: TTL.THEME }) },

  getLanguage()     { return getCookie(PREFS.LANGUAGE) || 'pt-BR' },
  setLanguage(lang) { setCookie(PREFS.LANGUAGE, lang, { ...COOKIE_OPTS, days: TTL.LANGUAGE }) },

  getRememberMe()   { return getCookie(PREFS.REMEMBER_ME) === 'true' },
  setRememberMe(v)  { setCookie(PREFS.REMEMBER_ME, String(v), { ...COOKIE_OPTS, days: TTL.REMEMBER_ME }) },

  getSidebar()      { return getCookie(PREFS.SIDEBAR) || 'expanded' },
  setSidebar(state) { setCookie(PREFS.SIDEBAR, state, { ...COOKIE_OPTS, days: TTL.SIDEBAR }) },

  getAll() {
    return {
      theme:      this.getTheme(),
      language:   this.getLanguage(),
      rememberMe: this.getRememberMe(),
      sidebar:    this.getSidebar(),
    }
  },

  clearSession() {
    deleteCookie(PREFS.REMEMBER_ME)
    deleteCookie(PREFS.SIDEBAR)
  },

  clearAll() {
    Object.values(PREFS).forEach(name => deleteCookie(name))
  },
}
